import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  ModalCloseButton,
  Text,
  VStack,
  HStack,
  Spinner,
  Flex,
} from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { AuthContext } from "contexts/AuthContext";
import { axiosInstance } from "api/apiClient";
import { useTranslation } from "react-i18next";

const LeadInfoModal = ({ isOpen, onClose, leadId }) => {
    const history = useHistory();
    const { setSelectedLeadId, userInfos } = React.useContext(AuthContext);
    const { t } = useTranslation();
    const [conversation, setConversation] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (isOpen && leadId) {
            fetchConversation();
        }
    }, [isOpen, leadId]);

    const fetchConversation = async () => {
        setIsLoading(true);
        try {
            const response = await axiosInstance.get(`firestore/get_conversations?client_id=${userInfos.client_id}`);
            const conv = response.data.find((c) => c.thread_id === leadId);
            setConversation(conv);
        } catch (error) {
            console.error("Error fetching conversation:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleIdClick = () => {
        setSelectedLeadId(leadId);
        onClose();
        history.push("/admin/conversations");
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="sm">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Informations</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <VStack align="start" spacing={2}>
                        <Text>
                            <Text as="span" onClick={handleIdClick} color="#4279bd" textDecoration="underline" cursor="pointer">{t("leads.see_conversation")}</Text>
                        </Text>
                        {isLoading ? (
                            <Flex justify="center" w="100%" py={4}>
                                <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="blue.500" size="md" />
                            </Flex>
                        ) : conversation && (
                            <>
                                <Text>{t("conversations.device")} : {conversation.source ? conversation.source.device : 'N/A'}</Text>
                                <Text>Source : {conversation.source ? (conversation.source.url === "no source url found" ? "sandbox" : conversation.source.url) : 'N/A'}</Text>
                            </>
                        )}
                    </VStack>
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme="blue" mr={3} onClick={onClose}>
                        {t("close")}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default LeadInfoModal; 